import { importProvidersFrom } from '@angular/core';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

class ApiTranslateLoader implements TranslateLoader {
  constructor(private http: HttpClient, private orgId: string) {}

  getTranslation(lang: string): Observable<any> {
    return this.http.get(`/api/translation?lang=${lang}&orgId=${this.orgId}`);
  }
}

export function provideTranslateService() {
  return importProvidersFrom(
    TranslateModule.forRoot({
      defaultLanguage: 'en',
      loader: {
        provide: TranslateLoader,
        useFactory: (http: HttpClient) => new ApiTranslateLoader(http, 'your-org-id'),
        deps: [HttpClient]
      }
    })
  );
}